import { FunctionComponent } from 'preact';
import { useTranslation } from 'react-i18next';
import { DropOffFoundText } from './QuantityDropOffFound.styles';

interface QuantityDropOffFoundProps {
  quantity: number;
}

const QuantityDropOffFound: FunctionComponent<QuantityDropOffFoundProps> = ({
  quantity = 0,
}): JSX.Element => {
  const { t } = useTranslation();
  const getQuantityText = () => {
    if (quantity === 0) {
      return t('RETURN_NO_DROPOFF_FOUND');
    }

    return t('RETURN_FOUND_DROPOFF', { number: quantity });
  };
  return <DropOffFoundText>{getQuantityText()}</DropOffFoundText>;
};

export { QuantityDropOffFound };
